import { AfterViewChecked, Component, ElementRef, EventEmitter, Output, ViewChild, effect, input } from '@angular/core';
import { ViewEncapsulation } from '@angular/core';

import { IThread, IChatMessage } from '@lb/api/mylb/interfaces';
import { MDHeaderComponent, MDIconComponent } from '@melodic-ui/components';
import { ChatMessageComponent } from '@lb/components/chat-message/chat-message.component';
import { ChatMessageInputComponent } from '@lb/components/chat-message-input/chat-message-input.component';
import { LoaderComponent } from '@lb/components/loader/loader.component';

@Component({
	selector: 'lb-chat-message-area',
	standalone: true,
	imports: [MDHeaderComponent, MDIconComponent, ChatMessageComponent, ChatMessageInputComponent, LoaderComponent],
	templateUrl: './chat-message-area.component.html',
	styleUrl: './chat-message-area.component.scss',
	encapsulation: ViewEncapsulation.None
})
export class ChatMessageAreaComponent implements AfterViewChecked {
	conversation = input.required<IThread>();
	messages = input.required<IChatMessage[]>();
	loading = input<boolean>(false);
	userInitials = input<string>('U');
	showMenuToggle = input<boolean>(false);

	@Output() messageSent = new EventEmitter<string>();
	@Output() menuToggled = new EventEmitter<void>();

	@ViewChild('messagesContainer') messagesContainer?: ElementRef<HTMLDivElement>;

	private shouldScrollToBottom = false;
	private scrollTimeout?: number;

	constructor() {
		effect(() => {
			const messageCount = this.messages().length;
			if (messageCount > 0) {
				this.scheduleScroll();
			}
		});

		effect(() => {
			if (this.loading()) {
				this.scheduleScroll();
			}
		});
	}

	ngAfterViewChecked(): void {
		if (this.shouldScrollToBottom) {
			this.scrollToBottom();
			this.shouldScrollToBottom = false;
		}
	}

	private scheduleScroll(): void {
		if (this.scrollTimeout) {
			clearTimeout(this.scrollTimeout);
		}
		this.scrollTimeout = window.setTimeout(() => {
			this.shouldScrollToBottom = true;
		}, 50);
	}

	private scrollToBottom(): void {
		if (this.messagesContainer?.nativeElement) {
			this.messagesContainer.nativeElement.scrollTop = this.messagesContainer.nativeElement.scrollHeight;
		}
	}

	onMessageSent(message: string): void {
		this.messageSent.emit(message);
		this.shouldScrollToBottom = true;
	}

	onRetryMessage(message: string): void {
		this.messageSent.emit(message);
		this.shouldScrollToBottom = true;
	}

	toggleMenu(): void {
		this.menuToggled.emit();
	}
}
